import { useEffect, useState } from "react";
import dayjs from "dayjs";

import { HttpAdminApi } from "../../../../interface/admin-api";

const adminApi = new HttpAdminApi();

export interface PrevWinInfo {
  evntNm: string;
  ofrNm: string;
}

// 같은 방송에서 이미 종료된 이벤트의 당첨자 (아이디 → 당첨 이력).
// 응모 기록의 아이디·고객번호는 이벤트마다 암호문이 달라 비교할 수 없으므로, 서버가 복호화해 준 아이디로 비교한다.
// 다시 조회하는 동안에는 직전 결과를 유지한다 (같은 이벤트를 다시 불러올 때 표시가 깜빡이지 않게)
export function usePrevEventWinners(broadSeq: string, eventInfo: any) {
  const [prevWinners, setPrevWinners] = useState<Map<string, PrevWinInfo[]>>(new Map());

  useEffect(() => {
    if (!broadSeq || eventInfo?.sk === undefined) return;

    let canceled = false;

    const get_prev_winners = async () => {
      const listRes = await adminApi.post({ command: "get_event_list", broad_seq: broadSeq });
      if (listRes.code !== "200") {
        console.error("get_prev_winners : ", listRes.response?.error_msg);
        return;
      }

      const endEvents = (listRes.response.event_list || []).filter(
        (event: any) => event.event_status === "END" && event.sk !== eventInfo.sk && event.draw_result?.length > 0
      );

      // get_event_list 의 draw_result 는 아이디가 암호화된 상태라 get_event_info 로 복호화된 당첨자를 받는다
      const infoResList = await Promise.all(
        endEvents.map((event: any) =>
          adminApi.post({ command: "get_event_info", broad_seq: broadSeq, event_seq: event.sk })
        )
      );

      const nextWinners = new Map<string, PrevWinInfo[]>();
      for (const infoRes of infoResList) {
        if (infoRes.code !== "200") continue;
        const endEvent = infoRes.response.event_info;
        const evntNm =
          endEvent.event_condition?.evntNm || `이벤트-${dayjs(endEvent.start_dtm).format("YYYY-MM-DD HH:mm:ss")}`;
        for (const winner of endEvent.draw_result || []) {
          if (!winner.user_id) continue;
          nextWinners.set(winner.user_id, [
            ...(nextWinners.get(winner.user_id) || []),
            { evntNm: evntNm, ofrNm: winner.ofrNm || "" },
          ]);
        }
      }

      if (!canceled) setPrevWinners(nextWinners);
    };

    get_prev_winners();

    return () => {
      canceled = true;
    };
  }, [broadSeq, eventInfo]);

  return prevWinners;
}
